module.exports = __webpack_public_path__ + "img/table-expansion-closed.b183b63e.svg";